import { Center } from '@chakra-ui/react/center'
import { Spinner } from '@chakra-ui/react/spinner'

import classes from './styles.module.css'

interface FullPageLoaderProps {
  minHeight?: string
}

export function FullPageLoader({ minHeight }: FullPageLoaderProps) {
  return (
    <Center
      className={classes.loaderCenter}
      style={minHeight ? { minHeight } : undefined}
    >
      <Spinner className={classes.spinner} aria-label="Загрузка..." />
    </Center>
  )
}
